'use client';

import { SearchBox } from 'react-instantsearch';

import {
  ScopeSearchAttributeModal,
  SortResultsModal as SortResultsModalWeb
} from '@/components/atomic/atoms';
import { SORT_BY_ITEMS_BID_LIST } from '@/config/searchkit/bidList';
import { SORT_BY_ITEMS_ORDER_LIST } from '@/config/searchkit/orderList';

import { getPlaceholderTextForSearchBox } from '@/helpers/searchkit';

const sortByItemsMap = {
  bidList: SORT_BY_ITEMS_BID_LIST,
  orderList: SORT_BY_ITEMS_ORDER_LIST
};

const SearchBoxFilterWeb = ({
  searchableAttribute,
  searchAttributeLabelList = [],
  searchBoxFilterContainerClass = 'flex gap-2 h-10 md:h-13.5 mt-4',
  searchBoxPlaceholderText = 'Search',
  searchkitFormClass = 'searchkit-searchbox before:bg-searchkit-search-box-form',
  setSearchableAttribute,
  source
}) => (
  <div className={searchBoxFilterContainerClass}>
    <div className='flex justify-between rounded-full relative w-full md:w-54.7'>
      <div>
        <SearchBox
          {...{
            classNames: {
              form: `relative ${searchkitFormClass} rounded-full h-8 md:h-[52px] w-full md:w-auto`,
              input: `relative w-84 md:w-54.7 rounded-full border border-platinum shadow-box h-9 md:h-[52px] focus:border-brand ${searchAttributeLabelList.length > 0 ? '!pl-[15rem]' : '!pl-12'} text-sm font-medium`
            },
            placeholder:
              searchBoxPlaceholderText ||
              getPlaceholderTextForSearchBox({
                searchableAttribute,
                searchAttributeLabelList
              })
          }}
        />
      </div>
      {searchAttributeLabelList.length > 0 && (
        <ScopeSearchAttributeModal
          {...{
            searchableAttribute,
            searchAttributeLabelList,
            setSearchableAttribute
          }}
        />
      )}
    </div>
    {source && (
      <SortResultsModalWeb
        {...{
          className: 'hidden md:flex',
          items: sortByItemsMap[source]
        }}
      />
    )}
  </div>
);

export default SearchBoxFilterWeb;
